/** Display formatting. Numbers, currency and counts — never dates (see datetime.ts). */

const NUM = new Intl.NumberFormat('en-IN')

/** 1204 -> "1,204", in the Indian grouping the client reads in. */
export function num(value: number | null | undefined): string {
  return value == null ? '—' : NUM.format(value)
}

/** Compact for tight spaces: 1204 -> "1.2k". Stat cards only. */
export function compactNum(value: number): string {
  if (value < 1000) return String(value)
  if (value < 1_000_000) return `${(value / 1000).toFixed(value < 10_000 ? 1 : 0)}k`
  return `${(value / 1_000_000).toFixed(1)}M`
}

/** Rupees. `estimate` prefixes with a tilde. */
export function inr(value: number, opts: { estimate?: boolean; decimals?: number } = {}): string {
  const { estimate = false, decimals = 2 } = opts
  const formatted = new Intl.NumberFormat('en-IN', {
    style: 'currency', currency: 'INR',
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  }).format(value)
  return estimate ? `~ ${formatted}` : formatted
}

/** 1_420_000 -> "1.42M tokens" */
export function tokens(value: number): string {
  return `${compactNum(value)} tokens`
}

/** 0.92 -> "92%" */
export function percent(fraction: number, decimals = 0): string {
  return `${(fraction * 100).toFixed(decimals)}%`
}

/** "Rahul Sharma" -> "RS". Two letters max; avatars are 28-40px. */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  const first = parts[0]?.[0] ?? ''
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase()
}

/** Truncate for a table cell. */
export function truncate(value: string, max: number): string {
  return value.length <= max ? value : `${value.slice(0, max - 1).trimEnd()}…`
}

/** "8f3c1a90-4b2e-..." -> "8f3c1a90…" for a monospace session-id cell. */
export function shortId(id: string, chars = 8): string {
  return id.length <= chars ? id : `${id.slice(0, chars)}…`
}

/** "/personal-loan" from an absolute or relative URL. Never throws. */
export function pagePath(url: string | null | undefined): string {
  if (!url) return '—'
  try {
    return new URL(url, 'https://paisa24finance.com').pathname || '/'
  } catch {
    return url
  }
}
